import React from "react";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";

const CancelledAppointmentTable = ({
  cancelledAppointments,
  loading,
  providerId,
  providerName,
  type,
}) => {
  const navigate = useNavigate(); // Hook to programmatically navigate

  return (
    <>
      <div className="overflow-x-auto">
        <table className="w-full border border-1 rounded-xl min-w-[800px]">
          <thead className="bg-gray-50  rounded-t-xl">
            <tr>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                No.
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Provider Name
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Distance (KM)
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Appointment Date
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Time Slot
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Consumer Pay
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                License/Registration No
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Cancelled By
              </th>
              <th className="py-3 px-4 text-left text-sm font-medium text-[#60646C]">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="pt-5 pb-7 justify-items-center">
                  <PropagateLoader color="#284184" loading={true} size={10} />
                </td>
              </tr>
            ) : cancelledAppointments?.length === 0 ? (
              <tr>
                <td colSpan="8" className="pt-5 pb-7 text-center text-gray-500">
                  No appointments available
                </td>
              </tr>
            ) : (
              cancelledAppointments &&
              cancelledAppointments.map((consumer, index) => (
                <tr
                  key={consumer.booking_id}
                  className="border-b hover:bg-gray-50"
                >
                  <td className="py-4 px-4">{index + 1}</td>
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                        <img
                          src={
                            consumer?.doc_sole_area_both_feet ||
                            `https://t4.ftcdn.net/jpg/03/64/21/11/360_F_364211147_1qgLVxv1Tcq0Ohz3FawUfrtONzz8nq3e.jpg`
                          }
                          alt={consumer.patient_name}
                          className="w-10 h-10 rounded-full"
                        />
                      </div>
                      {consumer.patient_name}
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    {Number(consumer?.km)?.toFixed(2)}
                  </td>
                  <td className="py-4 px-4">{consumer.date}</td>
                  <td className="py-4 px-4">{consumer.time}</td>
                  <td className="py-4 px-4">${consumer.amount}</td>
                  <td className="py-4 px-4">{consumer.license_no}</td>
                  <td className="py-4 px-4">{consumer.cancelled_by}</td>
                  <td className="py-4 px-4">
                    <button
                      className="text-blue-600 hover:text-blue-800 underline"
                      onClick={() =>
                        navigate("/cancelledPatientDetail", {
                          state: {
                            providerId,
                            providerName,
                            type,
                            bookingId: consumer?.booking_id,
                          },
                        })
                      }
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CancelledAppointmentTable;
